import { createContext, useContext } from "react";
import { AppTesterType } from "supporting";

const AppTesterContext = createContext<AppTesterType>({} as AppTesterType);

export const AppTesterProvider = AppTesterContext.Provider;

export const useAppTesterContext = () => {
  return useContext(AppTesterContext);
}import { createContext, useContext } from "react";
import { AppTesterType } from "supporting";

const AppTesterContext = createContext<AppTesterType>({} as AppTesterType);

export const AppTesterProvider = AppTesterContext.Provider;

export const useAppTesterContext = () => {
  return useContext(AppTesterContext);
}